import { Box, FormGroup, FormHelperText, FormLabel, OutlinedInput } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import clsx from "clsx";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
//style
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import { messages } from "resources/resources";
const useStylesGeneric = makeStyles(componentStylesGeneric);

export default function FormInput({ 
  name, 
  label, 
  control, 
  rules, 
  numberType, 
  tooltipLabel, 
  required: requiredProp,
  isRequired, 
  disabled, 
  trigger,
  getValues,
  otherFieldName,
  ...rest 
}) {
  const classes = useStylesGeneric();
  const theme = useTheme();
  const intl = useIntl();

  const requiredValue = isRequired ?? requiredProp;

  return (
    <FormGroup>
      <FormLabel>
        {label}
        {tooltipLabel && (
          <Tooltip title={tooltipLabel}>
            <HelpIcon className={classes.tooltipInfoIcon} />
          </Tooltip>
        )}
      </FormLabel>

      <Controller
        name={name}
        control={control}
        rules={{
          required: {
            value: requiredValue,
            message: intl.formatMessage(messages.Message_Generic_MandatoryField),
          },
          ...rules,
        }}
        render={({ field: { onChange, value, ref, ...field }, fieldState: { error } }) => (
          <>
            <OutlinedInput
              {...rest}
              {...field}
              disabled={disabled}
              value={value}
              ref={ref}
              onChange={(e) => {
                onChange(e);
                if (trigger && getValues && getValues(otherFieldName)) trigger(otherFieldName);
                if (trigger) trigger(name);
              }}
              fullWidth
              autoComplete="off"
              type={numberType ? "number" : "text"}
              classes={{
                notchedOutline: clsx({
                  [classes.borderWarning]: !!error,
                }),
              }}
            />

            <FormHelperText component={Box} color={theme.palette.warning.main + "!important"}>
              {error?.message}
            </FormHelperText>
          </>
        )}
      />
    </FormGroup>
  );
}
